import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/27.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Dopytujesz Emila o starego Tornaua"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p58,
            }}
            content={
                <div>
                    <ul>
                        <li>Dlaczego go tak nazywają? – pytasz Emila, spoglądając na znikającego między drzewami starego Tornaua.</li>
                        <li>Podobno jest ostatni z tych olędrów, co pola wokół rzeki osuszali, a jałowe ziemie czynili płodnymi. On wybrał inne życie, został gęsiarzem. Trzyma swoje gęsi na wyspie i pływa tam łódką, żeby się nimi opiekować. Taki dziwak…</li>
                        <li>Dlatego sam chodzi wieczorem nad rzeką? Wczoraj też tu był? – dopytujesz. Emil patrzy na ciebie kontrolnie, jakby to było o jedno pytanie za dużo.</li>
                        <li>Trzeba było jego zapytać. Ja nie znam go za dobrze.</li>
                    </ul>
                    <p>
                        Do Tarszewa dojeżdżacie w milczeniu.
                    </p>
                </div>
            }
        />

    );
}